import React from 'react';

import Group from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import Typography from '@pb/kit-component-typography';

import {GET_STARTED_CONTENT} from '../../constants';
import {useUserPrimaryAccountName} from '../../hooks/use-user-primary-account-name';
import {StepFooter} from '../step-footer/step-footer';

import {HowItWorks} from './components/how-it-works';
import {InfoCard} from './components/info-card';
import {NoteBanner} from './components/note-banner';
import {WhatIsSaml} from './components/what-is-saml';
import {WhatYouNeedList} from './components/what-you-need-list';

import {cardsRow, getStartedContainer} from './get-started.module.styl';

type GetStartedProps = {
    onContinue: () => void,
    onBack?: () => void,
    saving?: boolean,
};

export const GetStarted: React.FC<GetStartedProps> = ({onContinue, onBack, saving}) => {
    const {accountName} = useUserPrimaryAccountName();

    return (
        <Group direction="v" gap="l" className={getStartedContainer}>
            <Group direction="v" gap="xs">
                <Typography variant="heading-level-1">
                    Set Up Single Sign-On (SSO){accountName ? ` for ${accountName}` : ''}
                </Typography>
                <Typography variant="body-level-1">
                    {GET_STARTED_CONTENT.subtitle}
                </Typography>
            </Group>

            <div className={cardsRow}>
                <InfoCard icon={Icons.CHECK} title={GET_STARTED_CONTENT.whatYouNeed.heading}>
                    <WhatYouNeedList items={GET_STARTED_CONTENT.whatYouNeed.items}/>
                </InfoCard>
                <InfoCard icon={Icons.INFO} title={GET_STARTED_CONTENT.howItWorks.heading}>
                    <HowItWorks description={GET_STARTED_CONTENT.howItWorks.description}/>
                </InfoCard>
            </div>

            <WhatIsSaml/>
            <NoteBanner message={GET_STARTED_CONTENT.note}/>
            <NoteBanner message={GET_STARTED_CONTENT.legalExemption}/>
            <StepFooter onContinue={onContinue} onBack={onBack} busy={saving}/>
        </Group>
    );
};
